<template>
  <div class="invite-new">
    <div class="invite-second-crumb">
      <second-crumb />
    </div>
    <div class="invite-box">
      <h2>{{ $t('message["1212"]') }}</h2>
      <p>{{ $t('message["280"]') }}</p>
      <div class="invite-list">
        <a-form
          ref="inviteForm"
          layout="inline"
          :form="form"
          class="demo-form-inline"
          @submit.prevent="submitHandle('inviteForm')"
        >
          <div
            v-for="(item,index) in formData"
            :key="index"
            class="invite-item"
          >
            <a-form-item
              :required="false"
            >
              <div class="input_email">
                <a-input
                  v-decorator="[
                    `email[${index}]`,
                    {
                      validateTrigger: [ 'blur'],
                      rules: [{
                                required: true,
                                whitespace: true,
                                message: emailPlaceholder
                              },
                              {
                                validator: isEmailRe
                              },
                              {
                                validator: isErrorEmail
                              }
                      ]
                    }
                  ]"
                  :placeholder="emailPlaceholder"
                />
              </div>
            </a-form-item>
            <a-form-item
              v-if="item.isreg *1 === 1"
              class="member-name"
            >
              <span class="has-register-btn">
                {{ item.truename }}
              </span>
              <a-input
                v-show="hide"
                v-decorator="[
                  `truename[${index}]`,{
                    initialValue: item.truename
                  }]"
                :placeholder="nameTit"
              />
            </a-form-item>
            <a-form-item
              v-if="item.isreg *1 !== 1"
              class="member-name"
            >
              <a-input
                v-decorator="[
                  `truename[${index}]`,{
                    rules:[{ required: true, message: namePlaceholder}]
                  }]"
                :placeholder="nameTit"
              />
            </a-form-item>
            <a-form-item>
              <a-button
                v-if="(index!==0)"
                class="del-invite-btn"
                @click="delteFormItem(index)"
              >
                {{ $t('message["962"]') }}
              </a-button>
            </a-form-item>
          </div>
          <div class="invite-item">
            <a-form-item>
              <a-button
                class="add-invite-btn"
                @click="addItem"
              >
                <i class="icon iconfont iconicon-test10" />
                {{ $t('message["1346"]') }}
              </a-button>
            </a-form-item>
          </div>
          <div class="invite-item">
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
                :disabled="loading"
              >
                {{ $t('message["279"]') }}
              </a-button>
            </a-form-item>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import SecondCrumb from '@/components/pc/organization/invite/SecondCrumb'
import { mapActions } from 'vuex'
export default {
  components: {
    SecondCrumb
  },
  data () {
    return {
      initTeamId: '',
      isLoading: false,
      submitting: false,
      hide: false,
      initItem: {},
      formData: [
        {
          email: '',
          truename: '',
          isreg: 0
        }
      ]
    }
  },
  computed: {
    loading () {
      return this.submitting
    },
    args () {
      return this.$route.query
    },
    namePlaceholder () {
      return this.$t('message["823"]')
    },
    emailPlaceholder () {
      return this.$t('message["828"]')
    },
    nameTit () {
      return this.$t('message["1387"]')
    }
  },
  watch: {
  },
  created () {
    this.form = this.$form.createForm(this)
    // this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
    // this.form.getFieldDecorator('email', { initialValue: [], preserve: false })
    // this.form.getFieldDecorator('truename', { initialValue: [], preserve: false })
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/invite', ['ajaxSave', 'ajaxEmail']),
    addItem () {
      this.formData.push(
        {
          email: '',
          truename: '',
          isreg: 0
        }
      )
      // const { form } = this
      // form.setFieldsValue({
      //   keys: this.keys
      // })
    },
    // 删除邀请成员表单行
    delteFormItem (index) {
      const { form } = this
      // can use data-binding to set
      const emailDatas = form.getFieldValue('email')
      const nameDatas = form.getFieldValue('truename')
      emailDatas.splice(index, 1)
      nameDatas.splice(index, 1)
      form.setFieldsValue({
        email: emailDatas,
        truename: nameDatas
      })
      this.formData.splice(index, 1)
    },
    setFormData (data) {
      const { formData } = this
      for (let i = 0; i < data.length; i++) {
        formData[i].truename = data[i]
      }
    },
    submitHandle () {
      this.form.validateFieldsAndScroll(['email', 'truename'], async (err, values) => {
        const { form, formData } = this
        if (!err) {
          this.setFormData(form.getFieldValue('truename'))
          const chain = await this.ajaxSave()
          chain.params({ cid: this.args.cid * 1, inviteinfo: formData })
            .onSuccess(res => {
              this.$router.push({ name: 'OrgPerson', query: this.$route.query })
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    isEmailRe (rule, value, callback) {
      const length = this.form.getFieldValue('email').filter(item => item === value).length
      if (value && length > 1) {
        callback(new Error(this.$t('message["1511"]') + '！'))
      } else {
        callback()
      }
    },
    async isErrorEmail (rule, value, callback) {
      const index = this.form.getFieldValue('email').indexOf(value)
      const item = this.formData[index]
      let chain = await this.ajaxEmail()
      await chain.params({ email: value, cid: this.args.cid })
        .onNetSuccess((raw) => {
          const res = raw.data
          if (!res.error) {
            if (res.payload.isreg === 1) {
              // this.isHasReg = true
              item.isreg = 1
              item.truename = res.payload.truename
            } else {
              item.isreg = 0
            }
            item.email = value
          } else {
            // item.msg = res.message
            // item.isreg = 3
            if (value && res.message) {
              callback(new Error(res.message))
            } else {
              callback()
            }
          }
        })
        .config({ warn: false })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped >

  .invite-new {
    .ant-form-item{
      margin-bottom: 24px !important;
    }
    .invite-second-crumb {
      // border-bottom: 1px solid #ebebeb;
      // margin: 0 24px;
      height: 32px;
      line-height: 32px;
      margin-top: 8px;
    }

    .add-invite-btn {
      margin: 0 ;
      i {
        color: #ccc;
        font-size: 16px;
        margin-right: 4px;
      }
      // background: none;
      // color: #5077aa;
      // border: none;
    }

    .del-invite-btn {
      background: none;
      color: #5077aa;
      border: none;
    }

    .is-disabled {
      color: #c0c4cc;
    }

    .invite-box {
      // padding: 16px 24px;

      h2 {
        font-size: 14px;
        margin-top: 16px;
        font-weight: bold;
      }

      p {
        color: #b3b3b3;
        padding-top: 8px;
        line-height: 24px;
        margin-bottom: 24px;
      }

      .invite-list {
        .has-register-btn {
          border: 1px solid #ebebeb;
          background: #f5f5f5;
          color: #b3b3b3;
          display: inline-block;
          height: 30px;
          line-height: 30px;
          border-radius: 4px;
          padding: 0 16px;
          box-sizing: content-box;
        }

        .input_email .el-input input {
          width: 195px !important;
        }

        .member-name .el-input__inner {
          width: 120px;
        }

        .level-item {
          display: inline;
          // margin-right: 16px;
        }

        .level-item .el-input__inner {
          width: 160px;
        }
      }
    }
  }
</style>
